export const DEFAULT_QUANTITY_TO_BE_BATCHED = 1;
// Add more batch-related defaults
